export const OFFLINE = "connectivity@OFFLINE"
export const ONLINE = "connectivity@ONLINE"
export const CHECK_CONNECTIVITY = "connectivity@CHECK_CONNECTIVITY"
